export default "__VITE_ASSET__DRDQ4Qyx__"